var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "pansim-app-wrapper"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "main-body-container"
  }, [_c('router-view', {
    key: _vm.$i18n.locale
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pc-only-top-banner"
  }, [_c('div', {
    staticClass: "bar-content"
  }, [_c('p', {
    staticClass: "msg"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("판심 법무법인")]), _vm._v("은 주말/공휴일/야간에도 "), _c('span', {
    staticClass: "blue"
  }, [_vm._v("24시간 상담")]), _vm._v("이 가능합니다. ")]), _c('a', {
    staticClass: "call-link",
    attrs: {
      "href": "tel:010-8702-0200"
    }
  }, [_vm._v("📞 전화상담 010-8702-0200")])])]);

}]

export { render, staticRenderFns }